import { Box } from '@mui/material'
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch'
import { useAppStore } from '../../store/useAppStore'
import { VEHICLE_SIDES } from '../../constants'
import { IVehicleData } from '../../store/slices/vehicleData'

// Import the damage pin icon directly from assets
import damagePin from '../../assets/icons/damagePin.svg'

const SelectDamagedSection = ({
  coordinates,
  addNewDamage,
  vehicleSide = '',
  preventScroll = false,
}: {
  coordinates: [number, number] | null
  addNewDamage: (
    event: any,
    scale: number,
    positionX: number,
    positionY: number
  ) => void
  vehicleSide?: string
  preventScroll?: boolean
}) => {
  const vehicleData = useAppStore((state) => state.vehicleData) as IVehicleData
  const tabValue = useAppStore((state) => state.tabValue)

  // Use vehicleSide from props if provided, otherwise fallback to tabValue
  const sideIndex = vehicleSide
    ? VEHICLE_SIDES.findIndex((side) => side === vehicleSide)
    : tabValue

  // Make sure we have a valid index, fallback to tabValue if invalid
  const validSideIndex = sideIndex >= 0 ? sideIndex : tabValue
  const currentSideData = vehicleData[validSideIndex]

  const [x, y] = coordinates || [0, 0]
  const width = 344
  const height = 245

  return (
    <Box flexGrow={1} display="flex">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexGrow={1}
        mx={-1}
        sx={{
          overflow: 'hidden',
          '& .react-transform-component': {
            overflow: 'initial',
            '& img': {
              pointerEvents: 'auto',
            },
          },
        }}
      >
        <Box
          height={height}
          width={width}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <TransformWrapper
            initialScale={1}
            initialPositionX={0}
            initialPositionY={0}
            wheel={{ disabled: preventScroll }}
            panning={{ disabled: preventScroll }}
          >
            {({
              instance: {
                transformState: { scale, positionX, positionY },
              },
            }) => {
              return (
                <TransformComponent>
                  <Box
                    sx={{
                      position: 'relative',
                    }}
                    component="span"
                  >
                    <Box
                      sx={{
                        pointerEvents: 'none',
                        '& img': {
                          pointerEvents: 'none !important',
                        },
                        scale: 1 / scale,
                        position: 'absolute',
                        top: `${y}%`,
                        left: `${x}%`,
                      }}
                      hidden={!coordinates}
                      component="span"
                    >
                      <Box
                        component="img"
                        src={damagePin}
                        alt="Damage Pin"
                        sx={{
                          display: 'block',
                          marginTop: `${-10}px`,
                          marginLeft: `${-10}px`,
                        }}
                      />
                    </Box>

                    <Box
                      component={'img'}
                      onClick={(event: any) => {
                        addNewDamage(event, scale, positionX, positionY)
                      }}
                      alt="Vehicle Damage pins"
                      src={
                        currentSideData?.photo && currentSideData.photo
                          ? currentSideData.photo
                          : currentSideData?.defaultPlaceholder
                      }
                      sx={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        display: 'inherit',
                      }}
                    />
                  </Box>
                </TransformComponent>
              )
            }}
          </TransformWrapper>
        </Box>
      </Box>
    </Box>
  )
}

export default SelectDamagedSection
